<template>
  <div v-loading.fullscreen.lock="fullscreenLoading" class="edit-picker-box">
    <el-dialog title="" :visible="true" :before-close="closeBox">
      <div v-if="id == 0">
        <el-form :model="form" label-width="90px">
          <el-form-item label="代采员:">
            <el-select
              v-model="form.admin_id"
              filterable
              placeholder="代采员"
              style="width: 50%"
            >
              <el-option
                v-for="(item, index) in resData.memberOption"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色:">
            <el-select
              v-model="form.role_type"
              placeholder="角色"
              filterable
              style="width: 50%"
            >
              <el-option
                v-for="(item, index) in resData.roleOption"
                :key="item.key"
                :value="item.key"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市:">
            <el-select
              v-model="form.city"
              placeholder="城市"
              filterable
              style="width: 50%"
            >
              <el-option
                v-for="(item, index) in resData.cityOption"
                :key="item.key"
                :value="item.key"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="绑定代采组:">
            <el-select
              v-model="form.pgids"
              multiple
              placeholder="绑定代采组"
              filterable
              style="width: 50%"
            >
              <el-option
                v-for="(item, index) in resData.pgOption"
                :key="item.key1"
                :value="item.key1"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select
              v-model="form.status"
              placeholder="状态"
              style="width: 50%"
            >
              <el-option value="1" label="启用"></el-option>
              <el-option value="0" label="禁用"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button style="width: 25%" @click="closeBox">取消</el-button>
            <el-button type="success" style="width: 25%" @click="submitData"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div v-if="id > 0">
        <el-form :model="form" label-width="90px">
          <el-form-item label="代采员:">
            <el-select
              v-model="form.admin_id"
              filterable
              placeholder="代采员"
              style="width: 50%"
              disabled
            >
              <el-option
                v-for="(item, index) in resData.memberOption"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色:">
            <el-select
              v-model="form.role_type"
              placeholder="角色"
              filterable
              style="width: 50%"
            >
              <el-option
                v-for="(item, index) in resData.roleOption"
                :key="item.key"
                :value="item.key"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市:">
            <el-select
              v-model="form.city"
              placeholder="城市"
              filterable
              style="width: 50%"
            >
              <el-option
                v-for="(item, index) in resData.cityOption"
                :key="item.key"
                :value="item.key"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="绑定代采组:">
            <el-select
              v-model="form.pgids"
              multiple
              placeholder="绑定代采组"
              filterable
              style="width: 50%"
            >
              <el-option
                v-for="(item, index) in resData.pgOption"
                :key="item.key1"
                :value="item.key1"
                :label="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态:">
            <el-select
              v-model="form.status"
              placeholder="状态"
              style="width: 50%"
            >
              <el-option value="1" label="启用"></el-option>
              <el-option value="0" label="禁用"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-button style="width: 25%" @click="closeBox">取消</el-button>
            <el-button type="success" style="width: 25%" @click="submitData"
              >确认</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      form: {
        pgid: [],
      },
      resData: {},
      fullscreenLoading: false,
    };
  },
  computed: {
    filteredForm() {
      for (let key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.fullscreenLoading = true;
      let userPormise = new Promise((resolve, rejected) => {
        this.$http
          .post("/erp/PurchaseGroup/getSelectOption")
          .then((result) => {
            this.fullscreenLoading = false;
            if (result.data.code != 200) {
              return this.$message.error(result.data.msg);
            }
            resolve(result.data.data);
          })
          .catch((err) => {});
      });
      userPormise.then((res) => {
        this.resData = res;
        if (this.id < 1) {
          return false;
        }
        this.fullscreenLoading = true;
        this.$http
          .post("/erp/PurchaseGroup/purchaseGroupMemberDetail", {
            id: this.id,
          })
          .then((result) => {
            this.fullscreenLoading = false;
            if (result.data.code != 200) {
              return this.$message.error(result.data.msg);
            }
            let temp = result.data.data;
            this.form = {
              pgids: temp.pgids,
              city: temp.city,
              status: temp.status,
              admin_id: temp.admin_id,
              role_type: temp.role_type,
              id: temp.pg_member_id,
            };
          })
          .catch((err) => {});
      });
    },
    submitData() {
      this.fullscreenLoading = true;
      this.$http
        .post("/erp/PurchaseGroup/savePurchaseGroupMember", this.filteredForm)
        .then((result) => {
          this.fullscreenLoading = false;
          if (result.data.code != 200) {
            return this.$message.error(result.data.msg);
          }
          this.$message.success("操作成功");
          this.closeBox();
        })
        .catch((err) => {});
    },
    closeBox() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>

<style scoped>
.bottom-buttom {
  display: flex;
  flex-direction: row;
}

.el-dialog {
  width: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/purchasegroup/components/EditMember.vue